  export const data = [
  {
    id: 1,
    name: "Microsoft ChatBot Demo in C#",
    github: "https://github.com/halgurdh/MinitoonChatBot",
  },
  {
    id: 2,
    name: "TruffleJS Blockchain",
    github: "https://github.com/halgurdh/blockchain-as-a-service",
  },
  {
    id: 3,
    name: "C# + ReactJS Posts",
    github: "https://github.com/halgurdh/react-dotnet",
  },
  {
    id: 4,
    name: "ReactJS TravelSite",
    github: "https://github.com/halgurdh/react-site",
  },
  {
    id: 5,
    name: "C# + ReactJS Budgeting App",
    github: "https://github.com/halgurdh/budgetAPI-react-dotnet",
  },
  {
    id: 6,
    name: "PhaserJS Games",
    github: "https://github.com/halgurdh/phaser-template",
    live: "https://www.youtube.com/watch?v=LkLJuYny5Oc",
  },
  {
    id: 7,
    name: "NextJS Movies",
    github: "https://github.com/halgurdh/nextjs-tvshows",
    live: "https://nextjs-tvshows.vercel.app/",
  },
  {
    id: 8,
    name: "WeatherApp",
    github: "https://github.com/halgurdh/WeatherApp",
    live: "https://halgurdh.github.io/WeatherApp/",
  },
  {
    id: 9,
    name: "myBooks",
    github: "https://github.com/halgurdh/myBooks",
    live: "https://halgurdh.github.io/myBooks/",
  },
  {
    id: 10,
    name: "ChilledPunks - Independent Music Label",
    live: "https://chilledpunks.com",
  },
  {
    id: 11,
    name: "CDG Brands - The Ultimate Brand Builder's Toolkit",
    live: "https://cdgbrands.com",
  },
  {
    id: 12,
    name: "Minitoon.Games - Indie Game Studio",
    live: "https://minitoon.games",
  }
  ];
